module.exports = __webpack_public_path__ + "img/ringsets@2x.30eaf75.jpg";